import _toConsumableArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/index.tsx
import { liftSuspense as liftSuspense3, sinkSuspense, SUSPENSE as SUSPENSE3, withDefault } from "@rx-state/core";

// src/internal/empty-value.ts
var EMPTY_VALUE = {};

// src/bind/connectFactoryObservable.ts
import { state } from "@rx-state/core";
function connectFactoryObservable(getObservable, defaultValue) {
  var args = defaultValue === EMPTY_VALUE ? [getObservable] : [getObservable, defaultValue];
  var obs = state.apply(void 0, args);
  return [function () {
    return useStateObservable(obs.apply(void 0, arguments));
  }, obs];
}

// src/bind/connectObservable.ts
import { state as state2 } from "@rx-state/core";
function connectObservable(observable, defaultValue) {
  var sharedObservable$ = defaultValue === EMPTY_VALUE ? state2(observable) : state2(observable, defaultValue);
  var useStaticObservable = function useStaticObservable() {
    return useStateObservable(sharedObservable$);
  };
  return [useStaticObservable, sharedObservable$];
}

// src/bind/index.ts
function bind(observable, defaultValue) {
  return (typeof observable === "function" ? connectFactoryObservable : connectObservable)(observable, arguments.length > 1 ? defaultValue : EMPTY_VALUE);
}

// src/shareLatest.ts
import { ReplaySubject, share } from "rxjs";
var shareLatest = function shareLatest() {
  return share({
    connector: function connector() {
      return new ReplaySubject(1);
    },
    resetOnError: true,
    resetOnComplete: true,
    resetOnRefCountZero: true
  });
};

// src/stateJsx.tsx
import { state as coreState } from "@rx-state/core";
import { createElement } from "react";

// src/useStateObservable.ts
import { liftSuspense as liftSuspense2, NoSubscribersError, StatePromise } from "@rx-state/core";
import { useRef as useRef2, useState as useState2 } from "react";

// src/internal/useSyncExternalStore.ts
import { useSyncExternalStore } from "use-sync-external-store/shim/index.js";

// src/Subscribe.tsx
import React, { useState, Suspense, useEffect, useRef, createContext, useContext } from "react";
import { Subscription } from "rxjs";
import { liftSuspense } from "@rx-state/core";
var SubscriptionContext = createContext(null);
var Provider = SubscriptionContext.Provider;
var useSubscription = function useSubscription() {
  return useContext(SubscriptionContext);
};
var p = Promise.resolve();
var Throw = function Throw() {
  throw p;
};
var Subscribe = function Subscribe(_ref) {
  var source$ = _ref.source$,
    children = _ref.children,
    fallback = _ref.fallback;
  var subscriptionRef = useRef(void 0);
  if (!subscriptionRef.current) {
    var s = new Subscription();
    subscriptionRef.current = {
      s: s,
      u: function u(src) {
        var _error = EMPTY_VALUE;
        var synchronous = true;
        s.add(liftSuspense()(src).subscribe({
          error: function error(e) {
            if (synchronous) {
              _error = e;
              return;
            }
            setSubscribedSource(function () {
              throw e;
            });
          }
        }));
        synchronous = false;
        if (_error !== EMPTY_VALUE) {
          throw _error;
        }
      }
    };
  }
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    subscribedSource = _useState2[0],
    setSubscribedSource = _useState2[1];
  if (subscribedSource !== null && subscribedSource !== source$) {
    if (source$ === void 0) {
      setSubscribedSource(source$);
    } else {
      try {
        ;
        source$.getValue();
        setSubscribedSource(source$);
      } catch (e) {}
    }
  }
  useEffect(function () {
    setSubscribedSource(source$);
    if (!source$) return;
    var subscription = liftSuspense()(source$).subscribe({
      error: function error(e) {
        return setSubscribedSource(function () {
          throw e;
        });
      }
    });
    return function () {
      subscription.unsubscribe();
    };
  }, [source$]);
  useEffect(function () {
    return function () {
      var _a;
      (_a = subscriptionRef.current) == null ? void 0 : _a.s.unsubscribe();
      subscriptionRef.current = void 0;
    };
  }, []);
  var actualChildren = subscribedSource === source$ ? /* @__PURE__ */React.createElement(Provider, {
    value: subscriptionRef.current.u
  }, children) : fallback === void 0 ? null : /* @__PURE__ */React.createElement(Throw, null);
  return fallback === void 0 ? actualChildren : subscribedSource === null ? fallback : /* @__PURE__ */React.createElement(Suspense, {
    fallback: fallback
  }, actualChildren);
};
var RemoveSubscribe = function RemoveSubscribe(_ref2) {
  var children = _ref2.children;
  return /* @__PURE__ */React.createElement(Provider, {
    value: null
  }, children);
};

// src/useStateObservable.ts
var useStateObservable = function useStateObservable(source$) {
  var subscription = useSubscription();
  var _useState3 = useState2(),
    _useState4 = _slicedToArray(_useState3, 2),
    setError = _useState4[1];
  var callbackRef = useRef2(void 0);
  if (!callbackRef.current) {
    var getValue = function getValue(src) {
      var result = src.getValue();
      if (result instanceof StatePromise) throw result.catch(function (e) {
        if (e instanceof NoSubscribersError) return e;
        throw e;
      });
      return result;
    };
    var gv = function gv() {
      var src = callbackRef.current.source$;
      if (!src.getRefCount() && !src.getDefaultValue) {
        if (!subscription) throw new Error("Missing Subscribe!");
        subscription(src);
      }
      return getValue(src);
    };
    callbackRef.current = {
      source$: null,
      args: [, gv, gv]
    };
  }
  var ref = callbackRef.current;
  if (ref.source$ !== source$) {
    ref.source$ = source$;
    ref.args[0] = function (next) {
      var subscription2 = liftSuspense2()(source$).subscribe({
        next: next,
        error: function error(e) {
          setError(function () {
            throw e;
          });
        }
      });
      return function () {
        subscription2.unsubscribe();
      };
    };
  }
  return useSyncExternalStore.apply(void 0, _toConsumableArray(ref.args));
};

// src/stateJsx.tsx
var state3 = function state3() {
  var result = coreState.apply(void 0, arguments);
  if (typeof result === "function") {
    return function () {
      return enhanceState(result.apply(void 0, arguments));
    };
  }
  return enhanceState(result);
};
var cache = /* @__PURE__ */new WeakMap();
function enhanceState(state$) {
  if (!cache.has(state$)) cache.set(state$, createElement(function () {
    return useStateObservable(state$);
  }, {}));
  var originalPipeState = state$.pipeState.bind(state$);
  return Object.assign(state$, cache.get(state$), {
    pipeState: function pipeState() {
      return enhanceState(originalPipeState.apply(void 0, arguments));
    }
  });
}
export { RemoveSubscribe, SUSPENSE3 as SUSPENSE, Subscribe, bind, liftSuspense3 as liftSuspense, shareLatest, sinkSuspense, state3 as state, useStateObservable, withDefault };